import rootReducer from "../../reducers";
import createStore from "./configure-store";

export const store = createStore(rootReducer);